import { linkPlaceholders } from '../config';

const getURLParam = (match, param) =>
  match.params[linkPlaceholders[param].replace(/:/g, '')];

export default getURLParam;
